import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { IFrameMenuMappings } from 'config';
import type { UseMenuChangeData } from './types';
import type { MenuItems, MenuItemGroupType, MenuItemType } from '@services';

export function useMenuChange(menu: MenuItems = []): UseMenuChangeData {
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const { pathname } = useLocation();
  // 当 menus 变化时更新 openKeys
  useEffect(() => {
    if (menu.length === 0) {
      return;
    }
    for (const item of menu) {
      const { children, key } = item as MenuItemGroupType;
      for (const child of children) {
        const { url, key: childKey, title } = child as MenuItemType;
        // 匹配 /aaa/bbb/ccc/ddd 子路由
        const pathnameParts = pathname.split('/').filter(Boolean);
        const urlParts = url.split('/').filter(Boolean);
        const isMatch = urlParts.every((part, index) => pathnameParts[index] === part);
        if (isMatch || IFrameMenuMappings.training[pathname] === url) {
          document.title = title as string;
          setSelectedKeys([childKey]);
          setOpenKeys([key, childKey]);
          return;
        }
      }
    }
  }, [menu, pathname]);

  // 只展开当前父级菜单
  const onOpenChange = (keys: string[]): void => {
    const latestOpenKey = keys.find(key => !openKeys.includes(key));
    setOpenKeys(latestOpenKey != null ? [latestOpenKey] : []);
  };

  // 处理菜单点击
  const onSelect = (info: {
    selectedKeys: string[];
    domEvent: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>;
  }): void => {
    if (info.domEvent.metaKey || info.domEvent.ctrlKey) { // metaKey: Mac Command键, ctrlKey: Windows键
      return;
    }
    setSelectedKeys(info.selectedKeys);
  };

  return {
    openKeys,
    selectedKeys,
    onOpenChange,
    onSelect
  };
}
